var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { Select, Store, Actions, ofActionDispatched } from '@ngxs/store';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { Observable, Subject } from 'rxjs';
import { CopyBookmark, CopyBookmarkSuccess, CopyBookmarkFailure } from 'src/app/bookmarks/state/bookmarks.actions';
import { takeUntil, filter } from 'rxjs/operators';
import { GetCollections } from 'src/app/organizations/state/organizations.actions';
import { BookmarksState } from 'src/app/bookmarks/state/bookmarks.state';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';
var AddTeamModelDialogComponent = /** @class */ (function () {
    function AddTeamModelDialogComponent(store, actions, formBuilder, dialogRef, snackBar, storageService, data) {
        this.store = store;
        this.actions = actions;
        this.formBuilder = formBuilder;
        this.dialogRef = dialogRef;
        this.snackBar = snackBar;
        this.storageService = storageService;
        this.data = data;
        this.ngUnsubscribe = new Subject();
        this.settings = __assign({}, data);
        // #TODO: AC, this should happen on first launch
        var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
        if (organization) {
            this.store.dispatch(new GetCollections(organization.id));
        }
    }
    AddTeamModelDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // read defaults
        var defaultGroupEdit = this.storageService.getLocalItem(StorageItemEnum.DefaultGroupEdit) === 'true';
        var defaultCollectionId = this.storageService.getLocalItem(StorageItemEnum.DefaultCollectionId);
        this.form = this.formBuilder.group({
            groupEditEnabled: ["" + defaultGroupEdit, Validators.required],
            collectionId: [defaultCollectionId]
        });
        // write defaults
        this.form.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (_a) {
            var groupEditEnabled = _a.groupEditEnabled, collectionId = _a.collectionId;
            if (groupEditEnabled) {
                _this.storageService.setLocalItem(StorageItemEnum.DefaultGroupEdit, groupEditEnabled);
            }
            else {
                _this.storageService.removeLocalItem(StorageItemEnum.DefaultGroupEdit);
            }
            if (collectionId) {
                _this.storageService.setLocalItem(StorageItemEnum.DefaultCollectionId, collectionId);
            }
            else {
                _this.storageService.removeLocalItem(StorageItemEnum.DefaultCollectionId);
            }
        });
        // close on success
        this.actions
            .pipe(ofActionDispatched(CopyBookmarkSuccess), filter(function (action) { return action.sourceId === _this.settings.bookmark.id && !!action.groupAccess; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (e) {
            _this.dialogRef.close(e.newId);
        });
        // notify on failure
        this.actions
            .pipe(ofActionDispatched(CopyBookmarkFailure), filter(function (action) { return action.id === _this.settings.bookmark.id; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (e) {
            _this.snackBar.open("Adding " + _this.settings.bookmark.title + " to your team models has failed. Please try again");
        });
    };
    AddTeamModelDialogComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    AddTeamModelDialogComponent.prototype.handleSubmit = function () {
        if (this.form.valid) {
            this.addTeamModel(this.settings.bookmark);
        }
    };
    AddTeamModelDialogComponent.prototype.addTeamModel = function (bookmark) {
        var _a = this.form.value, groupEditEnabled = _a.groupEditEnabled, collectionId = _a.collectionId;
        var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
        var collections = this.store.selectSnapshot(OrganizationsState.getCollections);
        // set group access    
        var groupAccess = {
            group_id: organization.id,
            member_edit: groupEditEnabled === 'true',
            visible: true
        };
        // set collection
        var collection = collections.find(function (_a) {
            var collection_id = _a.collection_id;
            return "" + collection_id === collectionId;
        });
        // copy bookmark
        this.store.dispatch(new CopyBookmark(bookmark.id, bookmark.type, groupAccess, collection));
    };
    __decorate([
        Select(OrganizationsState.getCollections),
        __metadata("design:type", Observable)
    ], AddTeamModelDialogComponent.prototype, "collections$", void 0);
    __decorate([
        Select(BookmarksState.getCopying),
        __metadata("design:type", Observable)
    ], AddTeamModelDialogComponent.prototype, "copying$", void 0);
    return AddTeamModelDialogComponent;
}());
export { AddTeamModelDialogComponent };
